import { useState, useEffect } from "react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../components/ui/select";

interface Option {
  value: number;
  label: string;
}

interface Props {
  onChange: (value: number | undefined) => void;
  clear: boolean;
  defaultValue?: number;
}

const ListOfBenefitGroupType = ({ onChange, clear, defaultValue }: Props) => {
  const [selectedOption, setSelectedOption] = useState<number | undefined>(
    defaultValue ?? undefined
  );

  const options: Option[] = [
    { value: 0, label: "(0) Both" },
    { value: 1, label: "(1) OP only" },
    { value: 2, label: "(2) IP only" },
  ];

  const handleChange = (value: string) => {
    const numericValue = value ? parseInt(value) : undefined;
    setSelectedOption(numericValue);
    if (onChange) {
      onChange(numericValue);
    }
  };

  useEffect(() => {
    if (clear) {
      setSelectedOption(undefined);
    }
  }, [clear]);

  useEffect(() => {
    setSelectedOption(defaultValue ?? undefined);
  }, [defaultValue]);

  return (
    <Select
      value={selectedOption != null ? selectedOption.toString() : undefined}
      onValueChange={handleChange}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Select an option" />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value.toString()}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default ListOfBenefitGroupType;
